
import { RouterProvider } from 'react-router-dom';
import './App.css'
import router from './Routes/Routes';
// import { useEffect } from 'react';
 


const App = () => {
 
 
  // useEffect(() => {
  //   const speakHello = () => {
  //     if ('speechSynthesis' in window) {
  //       const utterance = new SpeechSynthesisUtterance('Hey, im  Bappy. Welcome to my portfolio');
  //       speechSynthesis.speak(utterance);
  //     } else {
  //       console.log('Speech synthesis is not supported in this browser.');
  //     }
  //   };

  //   speakHello();
  // },);


  return (
    <div className='bg-black md:bg-[#0c0324] ' >
      <RouterProvider router={router} />     
    </div>
  );
};

export default App;